  <h3>Création de société</h3>
  <dx-form id="form"
  [formData]="societeToCreate">
      <dxi-item dataField="codeBo"></dxi-item>
			<dxi-item dataField="intitule"></dxi-item>
</dx-form>
<dx-button  text="Créer" (onClick)='creer()' ></dx-button>
